import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { filter, map, take, tap } from 'rxjs/operators';
import { AuthenticationActions } from './state/authentication.actions';
import { AuthState } from './state/authentication.reducer';
import { AuthenticationSelectors } from './state/authentication.selectors';

/**
 * In order to redirect direct requests for /login to default route this guard will handle redirect if needed
 * and for normal routing (where another route needs to redirect to login page if not authenticated)
 * this guard will return true on canActivate().
 */
@Injectable({
    providedIn: 'root'
})
export class AuthenticationLoginRedirectGuard implements CanActivate {
    authenticate$: Observable<AuthState>;

    constructor(private authenticationSelectors: AuthenticationSelectors,
                private router: Router) {
        this.authenticate$ = this.authenticationSelectors.selectAuthenticate();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        console.log('AuthenticationLoginRedirectGuard: Can Activate :::::::   ', state.url);

        return this.authenticate$
            .pipe(
                filter(authenticate => !authenticate.loading),
                map(authenticate => {
                    if (authenticate.user && authenticate.isUserAuthenticated) {
                        return true;
                    }

                    const navigation = this.router.getCurrentNavigation();
                    const replaceUrl = navigation.extras.replaceUrl || false;

                    if (replaceUrl && state.url.indexOf('login') > -1) {
                        // If requested path is /login we redirect to default route making that the requested route
                        this.router.navigate([''], {queryParams: route.queryParams});

                        return false;
                    }

                    return true;
                })
            );
    }
}
